export default "__VITE_ASSET__JmZuLcIn__"